export default "__VITE_ASSET__9393a7b3__"